<template>
  <div class="pagination-container">
    <el-pagination
      background
      :current-page="pageData.current"
      :page-sizes="[20, 30, 50, 100]"
      :page-size="pageData.size"
      layout="prev, pager, next, sizes, jumper"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    pageData: {
      type: Object,
      default: () => ({
        current: 1,
        size: 20
      })
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit('handle-current-change', val);
    },
    handleSizeChange(val) {
      this.$emit('handle-size-change', val);
    }
  }
};
</script>

<style lang="less" scoped>
.pagination-container {
  padding-top: 15px;
  display: flex;
  justify-content: flex-end;
  :deep(.el-pagination) {
    .btn-prev,
    .btn-next,
    .el-pager li {
      background: none;
      border: 1px solid @border-color;
      border-radius: 4px;
      color: #666a70;
      width: 32px;
      height: 32px;
      font-size: 14px;
    }
    .el-pager li {
      margin: 0 4px;
      &:not(.disabled):hover {
        color: @primary-color;
        border: 1px solid @primary-color;
      }
      &.active {
        border: 1px solid @primary-color;
        color: @primary-color;
        background: none;
      }
    }
    .el-input .el-input__inner {
      border-radius: 4px !important;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }

    .el-pagination__sizes {
      height: 32px;
      margin: 0;
    }
    .el-input__inner:focus {
      border-color: @border-color!important;
    }
    .el-pagination__jump {
      font-size: 14px;
      margin-left: 4px;
      height: 32px;
      .el-pagination__editor {
        height: inherit;
      }
    }
  }
}
</style>
<style lang="less">
.el-select-dropdown__item.selected {
  color: @primary-color!important;
}
</style>
